import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/icons/search.svg';
import _imports_1 from '@/assets/images/logo/Logo-Khanh-Hoa.png';
import _imports_2 from '@/assets/icons/arrow-down.svg';
const _hoisted_1 = {
  class: "header--mobile",
  ref: "scrollToTop"
};
const _hoisted_2 = {
  class: "header-mobile__wrap flex-between-center"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);
const _hoisted_7 = [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, [/*#__PURE__*/_createTextVNode(" CỔNG THÔNG TIN XÚC TIẾN ĐẦU TƯ "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" TỈNH KHÁNH HÒA ")], -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "search-icon"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu-drawer__title flex-center-center"
}, [/*#__PURE__*/_createTextVNode(" CỔNG THÔNG TIN XÚC TIẾN ĐẦU TƯ "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" TỈNH KHÁNH HOÀ ")], -1);
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick", "title"];
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1);
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = ["onClick", "title"];
const _hoisted_17 = {
  class: "loading-temp flex-center-center"
};
const _hoisted_18 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openMenuMobile()),
    type: "button",
    class: "navbar-toggle",
    id: "trigger-mobile"
  }, _hoisted_7), _hoisted_8, _createVNode(_component_el_button, {
    plain: "",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.openSearchDrawer()),
    class: "btn-menu"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  })]), _createVNode(_component_el_drawer, {
    class: "menu-drawer__wrap",
    direction: "ltr",
    "show-close": true,
    modelValue: _ctx.menuDrawer,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.menuDrawer = $event),
    title: "",
    size: _ctx.menuDrawerSize,
    "with-header": false
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "title__wrap flex-between-center px--5px"
        }, {
          default: _withCtx(() => [_hoisted_10, _hoisted_11]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: menu.path
          }, [_createElementVNode("li", {
            class: _normalizeClass(['menu-mobile__item flex-between-center text--bold', !_ctx.isEmpty(menu.child) ? 'has-submenu' : '', _ctx.expandSubMenus.indexOf(index) > -1 ? 'is-expand-child' : '']),
            onClick: $event => !_ctx.isEmpty(menu.child) ? _ctx.toggleSubMenu(index) : null
          }, [_createElementVNode("a", {
            onClick: $event => _ctx.goToPage(menu.path),
            title: menu.name
          }, _toDisplayString(menu.name), 9, _hoisted_13), !_ctx.isEmpty(menu.child) ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(['btn-expand-submenu flex-center-center', _ctx.expandSubMenus.indexOf(index) > -1 ? 'is-expand-child' : ''])
          }, _hoisted_15, 2)) : _createCommentVNode("", true)], 10, _hoisted_12), !_ctx.isEmpty(menu.child) ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(menu.child, subMenu => {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass(['menu-mobile__item sub-menu flex-start-center text--bold', _ctx.expandSubMenus.indexOf(index) > -1 ? 'is-expand' : ''])
            }, [_createElementVNode("a", {
              onClick: $event => _ctx.goToPage(subMenu.path),
              title: subMenu.name
            }, _toDisplayString(subMenu.name), 9, _hoisted_16)], 2);
          }), 256)) : _createCommentVNode("", true)], 64);
        }), 128))])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "size"])])), [[_vShow, _ctx.isMobile && !_ctx.isFullScreen], [_directive_loading, _ctx.isLoading]]), _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_vShow, !_ctx.isMobile && !_ctx.isFullScreen && _ctx.isLoadingMenu], [_directive_loading, _ctx.isLoadingMenu]]), _withDirectives(_createElementVNode("div", {
    class: "header--desktop__wrap",
    innerHTML: _ctx.menuStringObject.HTML,
    style: _normalizeStyle(_ctx.menuStringObject.CSS)
  }, null, 12, _hoisted_18), [[_vShow, !_ctx.isMobile && !_ctx.isFullScreen && !_ctx.isLoadingMenu]])], 64);
}